import {
    DependenciesPayload,
    Invoice,
    InvoiceLineItem,
} from '@sxm-de/dev-kits/web-sdk/types';
import { MapClientSdkToWebSdk } from '@sxm-de/dev-kits/web-sdk/utils';

export async function getInvoice(
    {
        billingProfileId,
        invoiceId,
    }: { billingProfileId: string; invoiceId: string },
    { clientSdk }: DependenciesPayload,
): Promise<Invoice> {
    const mapClientSdkToWebSdk: MapClientSdkToWebSdk<
        Awaited<ReturnType<typeof clientSdk.commerce.billing.getInvoice>>,
        Invoice
    > = (invoice) => {
        return {
            ...invoice,
            amountDue: invoice.amountDue || { value: 0 },
            amountPaid: invoice.amountPaid || { value: 0 },
            amountTotal: (invoice as any).amountTotal,
            appliedBalance: invoice.appliedBalance || { value: 0 },
            dueDate: invoice.dueDate || '',
            lines: invoice.lines.reduce((lines, line) => {
                if ('invoiceLine' in line) {
                    const { invoiceLine } = line;
                    return [
                        ...lines,
                        {
                            invoiceLine: {
                                ...invoiceLine,
                                amountAllocation: {
                                    ...invoiceLine.amountAllocation,
                                    taxAmount: invoiceLine.amountAllocation
                                        .taxAmount || { value: 0 },
                                    prorationAdjustmentApplied: invoiceLine
                                        .amountAllocation
                                        .prorationAdjustmentApplied || {
                                        value: 0,
                                    },
                                    mrfAmount: invoiceLine.amountAllocation
                                        .mrfAmount || {
                                        value: 0,
                                    },
                                },
                                offerId: invoiceLine.offerId || '',
                                productId: invoiceLine.productId || '',
                                subscriptionId:
                                    invoiceLine.subscriptionId || '',
                                taxes: {
                                    total: invoiceLine.taxes?.total || {
                                        value: 0,
                                    },
                                    breakdown:
                                        invoiceLine.taxes?.breakdown.map(
                                            (breakdown) => {
                                                return {
                                                    ...breakdown,
                                                    jurisdiction:
                                                        breakdown.jurisdiction ||
                                                        '',
                                                    jurisdictionLevel:
                                                        breakdown.jurisdictionLevel ||
                                                        '',
                                                    taxType:
                                                        breakdown.taxType || '',
                                                };
                                            },
                                        ) || [],
                                },
                            },
                        },
                    ];
                } else {
                    return lines;
                }
            }, [] as InvoiceLineItem[]),
            number: invoice.number || '',
            paymentMethodId: invoice.paymentMethodId || '',
            serviceAddress: {
                ...invoice.serviceAddress,
                addressLine1: invoice.serviceAddress?.addressLine1 || '',
                city: invoice.serviceAddress?.city || '',
                state: invoice.serviceAddress?.state || '',
                zipCode: invoice.serviceAddress?.zipCode || '',
            },
            subscriptionId: invoice.subscriptionId || '',
        };
    };

    const invoice = mapClientSdkToWebSdk(
        await clientSdk.commerce.billing.getInvoice(
            billingProfileId,
            invoiceId,
        ),
    );
    return invoice;
}
